/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (bipro-allgemein::Zeitraum)
 */
export interface InsurancePeriod {
  /**
   * Insurance begin.
   */
  begin?: string;
  /**
   * Insurance end.
   */
  end?: string;
  /**
   * Number of years spent in previous insurance.   (german: wie lange beim Vorversicherer)   (bipro-allgemein::AnzahlJahre)
   */
  numberOfYears?: any | null;
}
